<template>
  <v-container class="px-0 py-0" fluid v-if="isSearched">
    <v-card outlined>
      <v-card-title class="text-h6 py-2"> {{ $t('ELE0393') }} </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col>
            <v-card max-width="1200px" outlined>
              <v-card-title class="text-subtitle-1 py-0">
                {{ $t('ELE0177') }}
              </v-card-title>
              <v-card-text>
                <v-card outlined>
                  <v-simple-table class="header-gray" dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left v-data-table__divider" width="20%">{{ $t('ELE0042') }}</th>
                          <th class="text-left v-data-table__divider" width="30%">{{ $t('ELE0190') }}</th>
                          <th class="text-left v-data-table__divider" width="20%">{{ $t('ELE0042') }}</th>
                          <th class="text-left">{{ $t('ELE0190') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in infoList" :key="item.name">
                          <td class="v-data-table__divider">{{ item.info1.name }}</td>
                          <td :class="[item.info1.class, 'text-left v-data-table__divider']">
                            {{ item.info1.value }}
                          </td>
                          <td class="v-data-table__divider">{{ item.info2.name }}</td>
                          <td :class="item.info2.class">{{ item.info2.value }}</td>
                        </tr>
                        <tr>
                          <td class="v-data-table__divider">{{ $t('ELE0054') }}</td>
                          <td
                            colspan="3"
                            class="v-data-table__divider"
                            style="word-break: break-all; word-wrap: break-all; white-space: pre-line !important"
                          >
                            {{ indexDetail.remarks }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-card outlined>
              <v-card-title class="text-subtitle-1 py-1"> {{ $t('ELE0211') }} </v-card-title>
              <v-card-text>
                <v-card class="py-4" outlined v-for="app in apps" :key="app.cav">
                  <v-card-text>
                    <v-row>
                      <v-col>
                        <v-row>
                          <v-col>
                            <TextFieldRef :label="$t('ELE0437')" :value="app.inspTimingDtlName" />
                          </v-col>
                          <v-col>
                            <TextFieldRef :label="$t('ELE0157')" :value="app.cav" />
                          </v-col>
                          <v-col>
                            <TextFieldRef
                              :label="$t('ELE0154')"
                              :value="concatStr(app.inspectorCd, app.inspectorName)"
                            />
                          </v-col>
                          <v-col>
                            <TextFieldRef :label="$t('ELE0175')" :value="app.inspQty" right />
                          </v-col>
                          <v-col>
                            <TextFieldRef
                              :label="$t('ELE0188')"
                              :value="showInspResultName('InspResultCd.', app.inspResultCd, false)"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <TextAreaRef :label="$t('ELE0054')" :value="app.remarks" rows="1" />
                          </v-col>
                          <v-col></v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <v-card outlined class="px-0 py-0">
                          <v-data-table
                            :headers="headersApp"
                            :items="app.defects"
                            dense
                            fixed-header
                            disable-pagination
                            hide-default-footer
                            mobile-breakpoint="0"
                          >
                            <template v-slot:[`item.defectCd`]="{ item }">
                              <PartDefectInput
                                v-model="item.defectCd"
                                :partCd="indexDetail.partCd"
                                :partRev="app.partRev"
                                disabled
                              />
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-card outlined>
              <v-card-title class="text-subtitle-1 py-1"> {{ $t('ELE0229') }} </v-card-title>
              <v-card-text>
                <v-card class="py-4" outlined v-for="dim in dims" :key="dim.cav">
                  <v-card-text>
                    <v-row>
                      <v-col>
                        <v-row>
                          <v-col>
                            <TextFieldRef :label="$t('ELE0437')" :value="dim.inspTimingDtlName" />
                          </v-col>
                          <v-col>
                            <TextFieldRef :label="$t('ELE0157')" :value="dim.cav" />
                          </v-col>
                          <v-col>
                            <TextFieldRef
                              :label="$t('ELE0154')"
                              :value="concatStr(dim.inspectorCd, dim.inspectorName)"
                            />
                          </v-col>
                          <v-col>
                            <TextFieldRef :label="$t('ELE0175')" :value="dim.inspQty" right />
                          </v-col>
                          <v-col>
                            <TextFieldRef
                              :label="$t('ELE0188')"
                              :value="showInspResultName('InspResultCd.', dim.inspResultCd, dim.isOutCl)"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <TextAreaRef :label="$t('ELE0054')" :value="dim.remarks" rows="1" />
                          </v-col>
                          <v-col></v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <v-card outlined>
                          <v-data-table
                            :headers="createHeaderDim(dim)"
                            :items="dim.characs"
                            dense
                            fixed-header
                            disable-pagination
                            hide-default-footer
                            mobile-breakpoint="0"
                          >
                            <template v-slot:item="{ item }">
                              <tr>
                                <td
                                  v-for="header in createHeaderDim(dim)"
                                  :key="header.value"
                                  class="v-data-table__divider"
                                  :style="{ backgroundColor: header.getColorFunc ? header.getColorFunc(item) : '' }"
                                >
                                  {{
                                    header.getDisplayValueFunc
                                      ? header.getDisplayValueFunc(item)
                                      : header.getDisplayNameFunc
                                      ? header.getDisplayNameFunc(item)
                                      : item[header.value]
                                  }}
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { MeasFmtCd, DimJudgeCd } from '@/enum'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtil from '@/mixin/date-utils.js'
import StringUtils from '@/mixin/string-utils.js'
import BigNumber from 'bignumber.js'
import Btn from '@/components/atoms/base/button/Btn.vue'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import TextAreaRef from '@/components/atoms/base/text-field/TextAreaRef'
import PartDefectInput from '@/components/atoms/select/PartDefectInput'

export default {
  name: 'InspResultForm',

  mixins: [APIUtils, Message, Loading, DateUtil, StringUtils],

  components: {
    Btn,
    TextFieldRef,
    TextAreaRef,
    PartDefectInput,
  },

  props: {
    inspIndexNo: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isSearched: false,
      headersApp: [
        {
          text: this.$t('ELE0011'),
          value: 'defectCd',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
          width: '400',
        },
        {
          text: this.$t('ELE0174'),
          value: 'defectQty',
          align: 'right',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
          width: '200',
        },
        { text: this.$t('ELE0054'), value: 'remarks', sortable: false, cellClass: 'py-1' },
      ],
      apps: [],
      dims: [],
      indexDetail: null,
      infoList: [],
      overBackgroundColor: '#F2C6C6',
      belowBackgroundColor: '#DAE6F5',
    }
  },

  watch: {
    inspIndexNo: {
      handler(value) {
        this.search(value)
      },
    },
  },

  methods: {
    showInspResultName(key, value, isOutCl) {
      return this.getInspResultName(key, value, isOutCl)
    },
    formatMeasValue(characs, key) {
      //測定値からテーブル表示する文字にフォーマット
      const measFmtCd = characs.measFmtCd
      const measValue = characs['measValue' + String(key)]
      let displayValue = ''
      if (measFmtCd == MeasFmtCd.OK_NG && measValue !== '') {
        displayValue = this.$t(`DimJudgeCd.${measValue}`)
      } else {
        displayValue = measValue
      }
      return displayValue
    },

    getColorMeasValue(characs, key) {
      // 測定値に対応する色設定
      let color = ''
      const measFmtCd = characs.measFmtCd
      const measValue = characs['measValue' + String(key)]
      //OK_NGのとき
      if (measFmtCd == MeasFmtCd.OK_NG) {
        if (measValue == DimJudgeCd.NG) {
          color = this.overBackgroundColor
        }
      }
      //数値のとき
      else if (measFmtCd == MeasFmtCd.NUMBER) {
        const std = characs.standard || 0
        const upper = characs.saUpper ?? characs.upper ?? 0
        const lower = characs.saLower ?? characs.lower ?? 0

        // 上限値の測定結果判定
        if (BigNumber(measValue).gt(BigNumber(std).plus(upper))) {
          color = this.overBackgroundColor
        }
        // 下限値の測定結果判定
        else if (BigNumber(std).plus(lower).gt(BigNumber(measValue))) {
          color = this.belowBackgroundColor
        } else {
          color = ''
        }
      }
      return color
    },

    getUpperLimitColor(item, upper) {
      // upperまたはsaUpperカラムに対応する色設定
      let std = item.standard || 0
      upper = upper || 0

      const isOver = item.measValueList.some((key) => {
        const value = key.measValue
        return BigNumber(value).gt(BigNumber(std).plus(upper))
      })

      return isOver ? this.overBackgroundColor : ''
    },

    getLowerLimitColor(item, lower) {
      // lowerまたはsaLowerカラムに対応する色設定
      let std = item.standard || 0
      lower = lower || 0

      const isBelow = item.measValueList.some((key) => {
        const value = key.measValue
        if (value == null || value === '') return false
        return BigNumber(std).plus(lower).gt(BigNumber(value))
      })

      return isBelow ? this.belowBackgroundColor : ''
    },

    createHeaderDim(dim) {
      const headersDim = [
        { text: this.$t('ELE0091'), value: 'inspCharacCd', divider: true, sortable: false, visible: true },
        { text: this.$t('ELE0092'), value: 'inspCharacPoint', divider: true, sortable: false, visible: true },
        { text: this.$t('ELE0094'), value: 'inspGradeCd', divider: true, sortable: false, visible: true },
        {
          text: this.$t('ELE0095'),
          value: 'standard',
          divider: true,
          sortable: false,
          align: 'end',
          visible: true,
        },
        {
          text: this.$t('ELE0096'),
          value: 'upper',
          divider: true,
          sortable: false,
          align: 'end',
          visible: true,
          getColorFunc: (item) =>
            item.measFmtCd == MeasFmtCd.NUMBER && !item.saNo ? this.getUpperLimitColor(item, item.upper) : '',
        },
        {
          text: this.$t('ELE0097'),
          value: 'lower',
          divider: true,
          sortable: false,
          align: 'end',
          visible: true,
          getColorFunc: (item) =>
            item.measFmtCd == MeasFmtCd.NUMBER && !item.saNo ? this.getLowerLimitColor(item, item.lower) : '',
        },
        {
          text: this.$t('ELE0538'),
          value: 'clUpper',
          divider: true,
          sortable: false,
          align: 'end',
          visible: dim.hasCl ? true : false,
        },
        {
          text: this.$t('ELE0539'),
          value: 'clLower',
          divider: true,
          sortable: false,
          align: 'end',
          visible: dim.hasCl ? true : false,
        },
        {
          text: this.$t('ELE0273'),
          value: 'saStandard',
          divider: true,
          sortable: false,
          align: 'end',
          visible: true,
        },
        {
          text: this.$t('ELE0274'),
          value: 'saUpper',
          divider: true,
          sortable: false,
          align: 'end',
          visible: true,
          getColorFunc: (item) =>
            item.measFmtCd == MeasFmtCd.NUMBER && item.saNo ? this.getUpperLimitColor(item, item.saUpper) : '',
        },
        {
          text: this.$t('ELE0275'),
          value: 'saLower',
          divider: true,
          sortable: false,
          align: 'end',
          visible: true,
          getColorFunc: (item) =>
            item.measFmtCd == MeasFmtCd.NUMBER && item.saNo ? this.getLowerLimitColor(item, item.saLower) : '',
        },
        { text: this.$t('ELE0025'), value: 'measInstCd', divider: true, sortable: false, visible: true },
        {
          text: this.$t('ELE0181'),
          value: 'measResultCd',
          divider: true,
          sortable: false,
          visible: true,
          getDisplayNameFunc: (item) => this.showInspResultName('MeasResultCd.', item.measResultCd, item.isOutCl),
        },
      ].filter((header) => header.visible)

      for (let i = 1; i <= dim.maxNumOfMeas; i++) {
        headersDim.push({
          text: String(i),
          value: 'measValue' + String(i),
          divider: true,
          sortable: false,
          align: 'end',
          cellClass: 'py-1',
          getDisplayValueFunc: (item) => this.formatMeasValue(item, i),
          getColorFunc: (item) => this.getColorMeasValue(item, i),
        })
      }
      return headersDim
    },

    async search(inspIndexNo) {
      try {
        this.startLoading()

        this.dims = this.convertMeasValue(await API.get(`/inspDim/${inspIndexNo}`))
        this.apps = await API.get(`/inspApp/${inspIndexNo}`)

        if (this.dims.length > 0 || this.apps.length > 0) {
          let partRev = 0
          let inspCharacRev = 0
          let tecNo = ''
          for (let i = 0; i < this.dims.length; i++) {
            partRev = Math.max(partRev, this.dims[i].partRev)
            if (this.dims[i].inspCharacRev > inspCharacRev) {
              tecNo = this.dims[i].tecNo
              inspCharacRev = this.dims[i].inspCharacRev
            }
          }
          for (let i = 0; i < this.apps.length; i++) {
            partRev = Math.max(partRev, this.apps[i].partRev)
          }
          const indexDetail = await API.get(`/inspIndex/inspIndexes/${inspIndexNo}/lot`, {
            partRev: partRev,
          })
          this.indexDetail = indexDetail
          let info1 = []
          info1.push({ name: this.$t('ELE0137'), value: indexDetail.inspIndexNo, class: '' })
          info1.push({
            name: this.$t('ELE0188'),
            value: this.showInspResultName('InspResultCd.', indexDetail.inspResultCd, indexDetail.isOutCl),
            class: '',
          })
          info1.push({ name: this.$t('ELE0396'), value: this.toLocalDate(indexDetail.inspStartDatetime), class: '' })
          info1.push({ name: this.$t('ELE0266'), value: this.toLocalDate(indexDetail.inspEndDatetime), class: '' })
          info1.push({
            name: this.$t('ELE0236'),
            value: this.concatStr(indexDetail.wfCheckerCd, indexDetail.wfCheckerName),
            class: '',
          })
          info1.push({
            name: this.$t('ELE0237'),
            value: this.concatStr(indexDetail.wfApproverCd, indexDetail.wfApproverName),
            class: '',
          })
          info1.push({
            name: this.$t('ELE0116'),
            value: this.concatStr(indexDetail.inspCat1Cd, indexDetail.inspCat1Name),
            class: '',
          })
          info1.push({
            name: this.$t('ELE0117'),
            value: this.concatStr(indexDetail.inspCat2Cd, indexDetail.inspCat2Name),
            class: '',
          })

          let info2 = []
          info2.push({
            name: this.$t('ELE0057'),
            value: this.concatStr(indexDetail.manufacturerCd, indexDetail.manufacturerName),
            class: '',
          })
          info2.push({
            name: this.$t('ELE0048'),
            value: this.concatStr(indexDetail.inspCompanyCd, indexDetail.inspCompanyName),
            class: '',
          })
          info2.push({
            name: this.$t('ELE0059'),
            value: this.concatStr(indexDetail.partCd, indexDetail.partName),
            class: '',
          })
          info2.push({ name: this.$t('ELE0224'), value: indexDetail.partModel, class: '' })
          info2.push({ name: this.$t('ELE0049'), value: indexDetail.lotNo, class: '' })
          info2.push({ name: this.$t('ELE0050'), value: indexDetail.lotQty, class: 'text-right' })
          info2.push({ name: this.$t('ELE0089'), value: tecNo, class: '' })
          info2.push({ name: this.$t('ELE0053'), value: indexDetail.matlSpec, class: '' })
          let infoList = []
          for (let i = 0; i <= info1.length - 1; i++) {
            infoList.push({ info1: info1[i], info2: info2[i] })
          }
          this.infoList = infoList

          // タブ名称変更 "部品: part_cd - part_name"
          document.title = `${this.$t('ELE0059')} - ${this.concatStr(indexDetail.partCd, indexDetail.partName)}`

          this.isSearched = true
        } else {
          this.setErrorMessage(this.$t('MSG0049', { p0: inspIndexNo }))
        }
      } catch (error) {
        this.isSearched = false
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
      } finally {
        this.stopLoading()
      }
    },

    convertMeasValue(dims) {
      // 測定結果を表示しやすいように変換
      for (let i = 0; i < dims.length; i++) {
        const dim = dims[i]
        for (let j = 0; j < dim.characs.length; j++) {
          const charac = dim.characs[j]

          for (let num = 1; num <= dim.maxNumOfMeas; num++) {
            let obj = charac.measValueList.find((m) => m.numOfMeas == num)
            charac['measValue' + num] = obj?.measValue ?? ''
          }
        }
      }
      return dims
    },

    concatStr(str1, str2) {
      let result = ''
      if (str1 != null && str2 != null) {
        result = str1 + ' : ' + str2
      }
      return result
    },
  },
}
</script>
